<template>
	<CadastroViagemDialog
		:value="value"
		:viagem="viagem"
		@input="$emit('input', $event)"
		@saved="$emit('saved', $event)"
	/>
</template>

<script>
import CadastroViagemDialog from './cadastroViagem.vue';

export default {
	name: 'EditarViagemDialog',
	components: {
		CadastroViagemDialog,
	},
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		viagem: {
			type: Object,
			default: null,
		},
	},
};
</script>
